const publicRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../../views/User/Login.vue')
    },
    {
        path: '/Register',
        name: 'Register',
        component: () => import('../../views/User/Register.vue')
    }
]

export default publicRoutes
